var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.96 1H6.04C5.46475 1 5 1.46475 5 2.04V25.96C5 26.5352 5.46475 27 6.04 27H29.96C30.5352 27 31 26.5352 31 25.96V2.04C31 1.46475 30.5352 1 29.96 1ZM26.32 7.68525L24.994 8.956C24.877 9.04375 24.8217 9.18675 24.8445 9.3265V18.6768C24.8217 18.8197 24.877 18.9627 24.994 19.0472L26.294 20.318V20.6007H19.768V20.331L21.1103 19.0278C21.2435 18.8945 21.2435 18.8555 21.2435 18.6572V11.0912L17.506 20.5682H17.0022L12.6537 11.0912V17.445C12.6147 17.7115 12.709 17.9813 12.8975 18.173L14.646 20.2887V20.5715H9.68V20.2887L11.4285 18.173C11.617 17.9813 11.6982 17.7083 11.656 17.445V10.1C11.6787 9.89525 11.6007 9.697 11.4447 9.55725L9.89125 7.68525V7.4025H14.7175L18.442 15.5762L21.7212 7.409H26.32V7.68525Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.b27be838.svg";
export { ForwardRef as ReactComponent };